module.exports = __webpack_public_path__ + "img/34AB94_36DFC1_19F9EB_6C6E62-256px.455a23da.png";